module.exports = __webpack_public_path__ + "static/media/filter-sources.0dcb9d0e.png";